import type { SourcingChannelDetails } from 'api-clients/monolith';

import { POOL } from '@/types/channels';

/**
 * Returns true when a channel should be treated as free (no spend tracked).
 *
 * A channel is free when it is the Pool channel, an organic channel, or a
 * VONQ channel with no expected budget.
 *
 * @param channel - The sourcing channel details object.
 * @param hasNoBudget - Whether the channel has no budget configured.
 *   Pass `budget_stats.expected == null` for list-view rows, or
 *   `budget === 0` for edit-campaign/purchase contexts.
 */
export function isFreeChannel(
  channel: SourcingChannelDetails,
  hasNoBudget: boolean,
  hasNoContract: boolean,
): boolean {
  return (
    channel.slug === POOL ||
    !!channel.is_organic_channel ||
    (!!channel.is_vonq_channel && hasNoBudget && hasNoContract)
  );
}

/**
 * Determines if a channel is non-integrated.
 * A channel is non-integrated if it is not integratable, publishable, and not a Vonq channel.
 */
export function isNonIntegratedChannel(
  isIntegratable: boolean,
  isPublishable: boolean,
  isVonqChannel: boolean,
) {
  return !isIntegratable && !isPublishable && !isVonqChannel;
}
